var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-footer"},[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"dis-flex"},[_c('span',{},[_vm._v(" "+_vm._s(_vm.$t('footer.copyright', { year: new Date().getFullYear() }))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }